import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Alert from '@zr/components/Alert';

import ProfileWarning from './ProfileWarning';
import { useApplyFlowTelemetry } from '../hooks';
import { getAnswerComponent, questionPropType } from '../questionTypes';
import QuestionLabel from '../../components/QuestionLabel';

export function QuestionField({
  errorMessage, isMobile, question, showProfileWarning, totalQuestions,
}) {
  const { logView } = useApplyFlowTelemetry();
  const AnswerComponent = getAnswerComponent(question.question_type);

  // log screen view
  useEffect(() => {
    logView({ questionNumber: question.number, totalQuestions });
  }, [logView, question, totalQuestions]);

  return (
    <fieldset className="question_field">
      <QuestionLabel
        as="label"
        labelInputId={question.question_id}
        html={question.question_as_html}
        number={question.number}
        totalQuestions={totalQuestions}
      />
      {showProfileWarning && <ProfileWarning />}
      {errorMessage && <Alert type="danger" hasIcon message={errorMessage} aria-live="polite" />}
      <AnswerComponent
        error={errorMessage}
        isMobile={isMobile}
        key={question.question_id}
        question={question}
      />
    </fieldset>
  );
}

QuestionField.propTypes = {
  errorMessage: PropTypes.string,
  isMobile: PropTypes.bool,
  question: questionPropType.isRequired,
  showProfileWarning: PropTypes.bool,
  totalQuestions: PropTypes.number.isRequired,
};

QuestionField.defaultProps = {
  errorMessage: '',
  isMobile: false,
  showProfileWarning: false,
};

export default QuestionField;
